import React, { Component } from 'react';
import { withTranslation, Trans } from 'react-i18next';
import ConfiguratorSection from '../ConfiguratorSection';
import ConfiguratorImage from '../ConfiguratorImage';
import ConfiguratorOption from '../ConfiguratorOption';
import PdfForm from '../PdfForm';
import ShareFrom from '../ShareForm';
import Disclaimer from '../Disclaimer';
import { view06ImageOptions } from './views/view06'

class Summary extends Component {
    constructor(props) {
		super(props);

		this.state = {
			expanded: false
		};
    }

    render() {
		let imageOptions = view06ImageOptions;

        let image = (
			<ConfiguratorImage boat="X4_3MK2" configuration={this.props.configuration.exterior} options={imageOptions} />
        );


        return (
            <ConfiguratorSection image={image}>

                <ConfiguratorOption style={{ position: 'relative' }}>
                    <h1><Trans defaults='Summary' /></h1>
					<h2><Trans defaults='Congratulations!' /></h2>
					<p><Trans defaults='You have now configured the basics of an X4<sup>3</sup>. If you want a full configuration of your boat, please contact your local X-Yachts Dealer.' /></p>
					<PdfForm boat="X43MK2" country={this.props.country} countries={this.props.countries} configuration={this.props.configuration} code={this.props.code} />
					<ShareFrom configuration={this.props.configuration} boat="x43mk2" code={this.props.code} />
                    <Disclaimer />

                </ConfiguratorOption>
            </ConfiguratorSection>
        );
    }
}

export default withTranslation()(Summary);


// WEBPACK FOOTER //
// ./src/X43MK2/Summary.js